import { render, staticRenderFns } from "./PublisherResult.vue?vue&type=template&id=2bf34a65&"
import script from "./PublisherResult.vue?vue&type=script&lang=js&"
export * from "./PublisherResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports